export default function GridCard({ brand, updateBrand }) {
  console.log(brand.applicableStates);
  return (
    <>
      <li
        onClick={() => updateBrand(brand)}
        key={brand.BrandName}
        className="col-span-1 flex flex-col text-center bg-white rounded-lg shadow-md divide-y divide-gray-200 "
      >
        <div className="flex-1 flex flex-col p-7 bg-gray-main rounded-t-lg ">
          <div
            style={{
              backgroundImage: `url(${brand.LogoUrl})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
            className="w-40 h-40 flex-shrink-0 mx-auto rounded-full bg-white "
            alt=""
          ></div>
          <h3 className="mt-4 -mb-2 text-blue-primary text-xl font-normal">
            {brand.BrandName}
          </h3>

          {brand.applicableStates !== " " ? (
            <>
              <div className="border-t border-gray-300 pt-4 mt-4 -mb-2"></div>
              <h4 className="text-md">Applicable States:</h4>
              <p className="text-sm">{brand.applicableStates}</p>
            </>
          ) : null}
        </div>
        <div>
          <div className="-mt-px flex divide-x divide-gray-200">
            <div className="w-0 flex-1 flex">
              <a
                href="#"
                className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
              >
                <span className="">Select</span>
              </a>
            </div>
          </div>
        </div>
      </li>
      {/* {brand.applicableStates && (
        <>
          <div className="flex-1 flex flex-col p-7 bg-gray-main rounded-t-lg mt-4 rounded-lg">
            <h4 className="text-md">Applicable States:</h4>
            <p className="text-sm">{brand.applicableStates}</p>
          </div>
        </>
      )} */}
    </>
  );
}
